import { z } from "zod";

export const projectTimelineNoteSchema = z.object({
	date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
	note: z.string().min(1),
	isImportant: z.boolean().optional(),
});

export type ProjectTimelineNoteSchema = z.infer<typeof projectTimelineNoteSchema>;
